import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LangProvider } from "@/i18n";
import CookieBanner from "@/components/CookieBanner";
import Landing from "@/pages/Landing";
import RoomPage from "@/pages/RoomPage";
import Fote2027 from "@/pages/Fote2027";
import EventPage from "@/pages/EventPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminReset from "@/pages/admin/AdminReset";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <LangProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/cazare/:slug" element={<RoomPage />} />
          <Route path="/fote-2027" element={<Fote2027 />} />
          <Route path="/eveniment/:slug" element={<EventPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/reset" element={<AdminReset />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <CookieBanner />
      <Toaster position="top-center" richColors />
    </LangProvider>
  );
}

export default App;
